// extracted by mini-css-extract-plugin
export default {"button":"button_button__ktA4d","storeButton":"button_storeButton__8+SsE","ios":"button_ios__YyBtg","android":"button_android__FGSE8"};